export class UpdateFkEditorUseCase{
  constructor(repository) {
    this.repository = repository
  }
  async execute(ID_SOIL,FK_EDITOR){
    await this.repository.updateFkEditor(ID_SOIL,FK_EDITOR)
  }
}
